import React, { useState } from "react";
import {
  Button,
  Modal,
  ModalBody,
  FormLabel,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Input,
  Text,
} from "@chakra-ui/react";
import client from "../../helpers/Client";
import { FilePond, registerPlugin } from "react-filepond";
import { v4 as uuidv4 } from "uuid";
// Import FilePond styles
import "filepond/dist/filepond.min.css";

// Import FilePond plugins
import FilePondPluginFileRename from "filepond-plugin-file-rename";

// Register the plugins
registerPlugin(FilePondPluginFileRename);

export default function CreateAttachmentModal({
  object_model,
  object_id,
  state,
  dispatchAttachmentsChanged,
}) {
  const [uploadID, setUploadID] = useState(null);
  const [description, setDescription] = useState("");
  const [buttonLocked, setButtonLocked] = useState(false);
  const [errorData, setErrorData] = useState({});

  const handleCreate = () => {
    const data = {
      upload_id: uploadID,
      description: description,
      ...{ object_model, object_id },
    };
    client
      .post("/attachments/", data)
      .then(() => {
        dispatchAttachmentsChanged();
        state.onClose();
      })
      .catch((error) => {
        setErrorData(error.response.data);
      });
  };

  const handleUploadComplete = (_, file) => {
    setUploadID(file.serverId);
    setButtonLocked(false);
  };

  const handleUploadStart = () => {
    setButtonLocked(true);
  };

  const handleClose = () => {
    state.onClose();
  };
  const customFileRenameFunction = (file) => {
    return uuidv4() + file.extension;
  };

  return (
    <Modal isOpen={state.isOpen} onClose={state.onClose}>
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>Eklenti ekle</ModalHeader>
        <ModalCloseButton onClick={handleClose} />
        <ModalBody>
          <FilePond
            allowFileRename={true}
            fileRenameFunction={customFileRenameFunction}
            allowMultiple={false}
            chunkUploads={true}
            chunkForce={true}
            chunkSize={1000000}
            server={{
              url: process.env.REACT_APP_API_BASE_URL + "fp/",
              process: "./process/",
              patch: "./patch/",
              revert: "./revert/",
              load: "./load/",
              restore: "./restore/",
              fetch: "./fetch/",
            }}
            onaddfilestart={handleUploadStart}
            onprocessfile={handleUploadComplete}
            labelIdle='Dosyalarınızı bu kutunun içine sürükleyip bırakın ya da seçmek için <span class="filepond--label-action">buraya</span> tıklayın.'
          />
          {
            errorData.upload_id && errorData.upload_id.map((e) => (
              <Text color="red">{e}</Text>
            ))
          }
          <FormLabel>Açıklama</FormLabel>
          <Input onChange={(e) => setDescription(e.target.value)} />
          {
            errorData.description && errorData.description.map((e) => (
              <Text color="red">{e}</Text>
            ))
          }
          {
            errorData.non_field_errors && errorData.non_field_errors.map((e) => (
              <Text color="red">{e}</Text>
            ))
          }

        </ModalBody>
        <ModalFooter>
          <Button variant="outline" mr={3} onClick={handleClose}>
            İptal
          </Button>
          <Button
            isDisabled={buttonLocked}
            onClick={handleCreate}
            colorScheme="teal"
          >
            Kaydet
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
}
